__turbopack_context__.v({
  "content": "installment-list-presentation-module-scss-module__NXlIIW__content",
  "inner": "installment-list-presentation-module-scss-module__NXlIIW__inner",
  "title": "installment-list-presentation-module-scss-module__NXlIIW__title",
});
